// extracted by mini-css-extract-plugin
export var button = "_l0-2";
export var card = "_l0-0";
export var closeButtonContainer = "_l0-3";
export var iconContainer = "_l0-1";